import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);    
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
validate(datadim) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`/dimension/validate`, datadim);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
dimsetup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/dimension/dimsetup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
esatime() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/dimension/esatime");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
lookup(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'DimColName', 'kode', 'nama','aktif'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/dimsample/lookup${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}
};